module.exports = __webpack_public_path__ + "img/unit-alt.3ce9bab1.svg";